/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type HousingAmountAmountType = (typeof HousingAmountAmountType)[keyof typeof HousingAmountAmountType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HousingAmountAmountType = {
  rent: "rent",
  electricity: "electricity",
  gas: "gas",
  water: "water",
  other: "other",
} as const;
